import React, { useState } from "react";
import { CircularProgress, Box } from "@mui/material";

interface RenderImageProps {
  src: string;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  fallbackSrc?: string;
}

const RenderImage: React.FC<RenderImageProps> = ({
  src,
  alt = "image",
  style,
  className,
  fallbackSrc,
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = () => {
    if (!hasError) {
      setImgSrc(fallbackSrc || "");
      setHasError(true);
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {isLoading && (
        <CircularProgress size={25} sx={{ position: "absolute" }} />
      )}

      <img
        src={imgSrc}
        alt={alt}
        style={{
          ...style,
          display: isLoading ? "none" : "block",
        }}
        className={className}
        onError={handleError}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
      />
    </Box>
  );
};

export default RenderImage;
